import { Button, TableCell, TableRow, Typography } from '@mui/material'
import dayjs from 'dayjs'
import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'
import { hasFullPermission } from 'store'

export default function InActiveListItem({ item, districtTypes }) {
  const { t } = useTranslation()
  const { personId } = useParams()
  const navigate = useNavigate()

  return (
    <TableRow hover>
      <TableCell>
        <Typography variant="body2">{item.campus?.name}</Typography>
      </TableCell>
      <TableCell>
        <Typography variant="body2" color="text.secondary">
          {districtTypes?.find(dt => dt.code === item?.campus?.district?.type)?.name || '—'}
        </Typography>
      </TableCell>
      <TableCell>
        <Typography variant="body2" color="text.secondary">
          {item?.startDate ? dayjs(item.startDate).format('L') : '—'}
        </Typography>
      </TableCell>
      <TableCell>
        <Typography variant="body2" color="text.secondary">
          {item?.endDate ? dayjs(item.endDate).format('L') : '—'}
        </Typography>
      </TableCell>
      {hasFullPermission('people.campus') && (
        <TableCell align="right">
          <Button
            size="small"
            variant="outlined"
            onClick={() => navigate(`/people/staff/${personId}/campus/${item?.id}`)}
          >
            {t('More')}
          </Button>
        </TableCell>
      )}

    </TableRow>
  )
}
